import { ErrorHandler, Injectable } from '@angular/core';
import { SentryService } from '@sp-core/services/sentry/sentry.service';
import { CwrErrorHandler } from '@sp-core/error-handlers/cwr/cwr-error-handler';

/**
 * Angular resolves a non-multi token to its LAST provider, so registering both
 * SentryService and CwrErrorHandler for ErrorHandler silently disabled the first one.
 * This composite keeps both destinations alive behind a single ErrorHandler token.
 *
 * Each delegate is isolated: a handler that throws must not prevent the other one
 * from reporting, and must never surface as a second error to the user.
 */
@Injectable()
export class AppErrorHandler implements ErrorHandler {
  constructor(private sentryErrorHandler: SentryService, private cwrErrorHandler: CwrErrorHandler) {}

  public handleError(error: any): void {
    this.runSafely(() => this.sentryErrorHandler.handleError(error));
    this.runSafely(() => this.cwrErrorHandler.handleError(error));
  }

  private runSafely(report: () => void): void {
    try {
      report();
    } catch {
      // Reporting must never throw: swallowing here keeps the other destination working.
    }
  }
}
